module.exports = __webpack_public_path__ + "static/img/what-price-zh-CN.351cc09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what-price-zh-CN.png
// module id = mapi
// module chunks = 1